import axios from "axios";
import { baseURL } from "../../../utils/http/http-common";

export const LmsCourseCompleteStatus = async (data) => {
  try {
    const response = await axios.post(
      "https://lmsapi.projectinclusion.in/api/Course/GetShowCourseCompleteStatus",
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const CheckProfileCompletion = async (userId) => {
  try {
    const response = await axios.post(
      //`${baseURL}/Login/CheckProfileCompletion?UserID=${userId}`
      `${baseURL}/Login/CheckProfileCompletion?UserID=${userId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const CentralLogout = async (userId) => {
  try {
    const response = await axios.post(
      `${baseURL}/Login/CentralLogout?userId=${userId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};
